import { createSelector } from 'reselect'

import { hasPermission } from 'Components/Permissions/utils'
import { isWellShaped } from 'Global/Helpers/objectHelpers'
import { userPermissions as _userPermissions } from 'Components/Permissions/selectors'

export const user = state => state.auth.user

const rug = state => state.rugDetail.rug

export const detailRug = createSelector(
  [rug, _userPermissions],
  (rug, userPermissions) => {
    if (isWellShaped(rug, 'pictures')) {
      return {
        ...rug,
        pictures: rug.pictures.filter(picture => {
          if (picture.primary) {
            return true
          }

          if (picture.report !== null) {
            if (hasPermission('picture.picture.qcPicture', userPermissions)) {
              return true
            } else {
              return false
            }
          }

          if (hasPermission('picture.picture.nonPrimary', userPermissions)) {
            return true
          }

          return false
        }),
      }
    } else {
      return rug
    }
  },
)
